module.exports = "/assets/js/af08e7578fa04f8a5e64845da2b8e045.svg";